export default __webpack_public_path__ + "static/media/login-bg.5df21055.jpg";